<template>
  <div class="tax_reg">
    <el-divider content-position="left">税务报到进度</el-divider>
    <el-row>
      <el-col :span="4">
        <el-col :span="23">
          <el-select
            v-model="searchArr.company_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入公司名称筛选公司"
            size="mini"
            clearable
            :remote-method="searchRemoteCompanyMethod"
            :loading="searchLoading"
            @change="handleSearchCompanyChange"
          >
            <el-option
              v-for="searchCompany in searchCompanies"
              :key="searchCompany.id"
              :label="searchCompany.company_name"
              :value="searchCompany.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="4">
        <el-col :span="23">
          <el-select
            v-model="searchArr.id"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入订单编号"
            size="mini"
            @change="handleOrderChange"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in orderNums"
              :key="item.id"
              :label="item.order_num"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="4">
        <el-col :span="23">
          <el-select
            collapse-tags
            v-model="searchArr.status"
            placeholder="请选择办理完成状态"
            @change="handleOrderChange"
            size="mini"
            clearable
          >
            <el-option :value="1" label="未办理"></el-option>
            <el-option :value="2" label="办理中"></el-option>
            <el-option :value="3" label="已完成"></el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="4">
        <el-col :span="23">
          <el-select
            collapse-tags
            v-model="searchArr.step"
            placeholder="请选择办理节点"
            @change="handleOrderChange"
            size="mini"
            clearable
          >
            <el-option :value="1" label="确认材料"></el-option>
            <el-option :value="2" label="整理材料"></el-option>
            <el-option :value="3" label="园区操作"></el-option>
            <el-option :value="4" label="网厅申报"></el-option>
            <el-option :value="5" label="报到成功"></el-option>
            <el-option :value="6" label="客户配合授权"></el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="2" style="margin-right: 5px">
        <el-popover placement="bottom-start" v-model="searchVisible" width="320">
          <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
            <el-col :span="6" style="margin-top: 0.1rem">服务状态：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.service_status"
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option :value="3" label="服务中"></el-option>
                <el-option :value="4" label="服务完成"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">沟通顾问：</el-col>
            <el-col :span="18">
              <el-cascader
                v-model="searchArr.consultant"
                placeholder="请选择沟通顾问"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">行业特点：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.feature"
                filterable
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in features"
                  :key="item.industry_id"
                  :label="item.industry_name"
                  :value="item.industry_id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">注册类型：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.actual_reg_type"
                filterable
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in regTypes"
                  :key="item.reg_type_id"
                  :label="item.reg_type_name"
                  :value="item.reg_type_id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">服务人员：</el-col>
            <el-col :span="18">
              <el-cascader
                v-model="searchArr.operator"
                placeholder="请选择服务人员"
                :options="usersConvert"
                size="mini"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">订单来源：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.platform"
                filterable
                placeholder="请选择"
                clearable
                size="mini"
                @click.native="getFrom"
              >
                <el-option
                  v-for="item in fromOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">公司园区：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.park"
                filterable
                placeholder="请选择"
                clearable
                size="mini"
              >
                <el-option
                  v-for="option in parks"
                  :key="option.id"
                  :label="option.areaName"
                  :value="option.id"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
            <el-col :span="12" :offset="12">
              <el-button size="mini" @click="handleClearSearchGetData">清除</el-button>
              <el-button type="primary" @click="handleSearchGetData" size="mini"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
    </el-row>
    <el-table
    height="calc(100vh - 276px)"
      :data="orders"
      size="medium"
      style="width: 100%; margin-top: 0.2rem"
      v-cloak
      border
    >
      <el-table-column label="订单编号" width="200" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.order_num" placement="top">
            <div class="company_hover">
              <span class="count_style" style="display: inherit">
                <el-link
                  class="ellipsis-link"
                  type="primary"
                  @click="handleOrderInfo(scope.row.id, scope.row.order_num)"
                  >{{ scope.row.order_num }}</el-link
                >
              </span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed label="服务状态" width="90">
        <template slot-scope="scope">
          <div v-if="scope.row.service_status === '服务中'">
            <span class="dot" style="background-color: #88d023"></span>
            <el-link disabled>{{ scope.row.service_status }}</el-link>
          </div>
          <div v-else>
            <span class="dot" style="background-color: #ff8839"></span>
            <el-link disabled>{{ scope.row.service_status }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" width="200">
        <template slot-scope="scope">
          <el-tooltip
            :content="
              scope.row.company
                ? scope.row.company
                : scope.row.order_reg
                ? scope.row.order_reg.is_tax_report === 2
                  ? '公司注册中...'
                  : ''
                : ''
            "
            placement="top"
          >
            <el-link
              v-if="scope.row.company_id"
              type="primary"
              class="count-style"
              @click="fhandleCompanyInfoOpen(scope.row.company_id)"
              >{{ scope.row.company ? scope.row.company : "" }}</el-link
            >
            <span v-else class="count_style" style="display: inherit">{{
              scope.row.company
                ? scope.row.company
                : scope.row.order_reg
                ? scope.row.order_reg.is_tax_report === 2
                  ? "公司注册中..."
                  : ""
                : ""
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="订单来源" width="100">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.platform }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单类型" width="120">
        <template slot-scope="scope">
            <span class="count_style" style="display: inherit">{{
              scope.row.order_reg ? scope.row.order_reg.order_reg_name : ""
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="顾问">
        <template slot-scope="scope">
            <span class="hide-style">{{
              scope.row.advisor ? scope.row.advisor.username : ""
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户名称" width="110">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.customer_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户电话" width="170">
        <template slot-scope="scope">
            <!-- <span class="hide-style">{{ scope.row.customer_phone }}</span> -->
            <phone-com v-if="scope.row.customer_phone"
                  :comPhone="scope.row.customer_phone"
                  :vagaryPhone="scope.row.vagary_phone_custome"
                  style="display: inline-block"
                />
        </template>
      </el-table-column>
      <el-table-column label="法人名称" width="110">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.corporate_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="法人电话" width="170">
        <template slot-scope="scope">
            <!-- <span class="hide-style">{{ scope.row.corporate_phone }}</span> -->
            <phone-com v-if="scope.row.corporate_phone"
                  :comPhone="scope.row.corporate_phone"
                  :vagaryPhone="scope.row.vagary_phone_corporate"
                  style="display: inline-block"
                />
        </template>
      </el-table-column>
      <el-table-column label="确认材料" width="100">
        <template slot-scope="scope">
          <span
            class="hide-style"
            style="color: red; opacity: 0.75"
            v-if="!scope.row.step_one"
            >未处理</span
          >
          <span
            class="hide-style"
            style="color: green; opacity: 0.75"
            v-if="scope.row.step_one && scope.row.step_one.is_finish === 1"
            >办理中</span
          >
          <span
            class="hide-style"
            style="color: orange; opacity: 0.75"
            v-if="scope.row.step_one && scope.row.step_one.is_finish === 2"
            >已完成</span
          >
        </template>
      </el-table-column>
      <el-table-column label="整理材料" width="100">
        <template slot-scope="scope">
          <span
            class="hide-style"
            style="color: red; opacity: 0.75"
            v-if="!scope.row.step_two"
            >未处理</span
          >
          <span
            class="hide-style"
            style="color: green; opacity: 0.75"
            v-if="scope.row.step_two && scope.row.step_two.is_finish === 1"
            >办理中</span
          >
          <span
            class="hide-style"
            style="color: orange; opacity: 0.75"
            v-if="scope.row.step_two && scope.row.step_two.is_finish === 2"
            >已完成</span
          >
        </template>
      </el-table-column>
      <el-table-column label="园区操作" width="100">
        <template slot-scope="scope">
          <span
            class="hide-style"
            style="color: red; opacity: 0.75"
            v-if="!scope.row.step_three"
            >未处理</span
          >
          <span
            class="hide-style"
            style="color: green; opacity: 0.75"
            v-if="scope.row.step_three && scope.row.step_three.is_finish === 1"
            >办理中</span
          >
          <span
            class="hide-style"
            style="color: orange; opacity: 0.75"
            v-if="scope.row.step_three && scope.row.step_three.is_finish === 2"
            >已完成</span
          >
        </template>
      </el-table-column>
      <el-table-column label="网厅申报" width="100">
        <template slot-scope="scope">
          <span
            class="hide-style"
            style="color: red; opacity: 0.75"
            v-if="!scope.row.step_four"
            >未处理</span
          >
          <span
            class="hide-style"
            style="color: green; opacity: 0.75"
            v-if="scope.row.step_four && scope.row.step_four.is_finish === 1"
            >办理中</span
          >
          <span
            class="hide-style"
            style="color: orange; opacity: 0.75"
            v-if="scope.row.step_four && scope.row.step_four.is_finish === 2"
            >已完成</span
          >
        </template>
      </el-table-column>
      <el-table-column label="报到成功" width="100">
        <template slot-scope="scope">
          <span
            class="hide-style"
            style="color: red; opacity: 0.75"
            v-if="!scope.row.step_five"
            >未处理</span
          >
          <span
            class="hide-style"
            style="color: green; opacity: 0.75"
            v-if="scope.row.step_five && scope.row.step_five.is_finish === 1"
            >办理中</span
          >
          <span
            class="hide-style"
            style="color: orange; opacity: 0.75"
            v-if="scope.row.step_five && scope.row.step_five.is_finish === 2"
            >已完成</span
          >
        </template>
      </el-table-column>
      <el-table-column label="客户与配合授权" width="130">
        <template slot-scope="scope">
          <span
            class="hide-style"
            style="color: red; opacity: 0.75"
            v-if="!scope.row.step_six"
            >未处理</span
          >
          <span
            class="hide-style"
            style="color: green; opacity: 0.75"
            v-if="scope.row.step_six && scope.row.step_six.is_finish === 1"
            >办理中</span
          >
          <span
            class="hide-style"
            style="color: orange; opacity: 0.75"
            v-if="scope.row.step_six && scope.row.step_six.is_finish === 2"
            >已完成</span
          >
        </template>
      </el-table-column>
      <el-table-column label="天眼查完成截图" width="130">
        <template slot-scope="scope">
          <span
            class="hide-style"
            style="color: red; opacity: 0.75"
            v-if="!scope.row.step_seven"
            >未处理</span
          >
          <span
            class="hide-style"
            style="color: green; opacity: 0.75"
            v-if="scope.row.step_seven && scope.row.step_seven.is_finish === 1"
            >办理中</span
          >
          <span
            class="hide-style"
            style="color: orange; opacity: 0.75"
            v-if="scope.row.step_seven && scope.row.step_seven.is_finish === 2"
            >已完成</span
          >
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="办理信息" placement="top">
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              type="info"
              circle
              @click="handleEditOpen(scope.$index, scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-phone-outline"
              circle
              @click="handCallLogsOpen(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="企业微信群聊天记录"
            placement="top"
          >
            <el-button
              type="warning"
              :disabled="scope.row.wx_work_chat_com ? false : true"
              @click="
                handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
              "
              size="mini"
              icon="el-icon-s-comment"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      :title="'办理信息： ' + orderNum"
      :visible.sync="editDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      :before-close="handleClearList"
      size="40%"
    >
    <div class="drawer-title" slot="title">办理信息： {{ orderNum }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <el-col :span="24">
            <el-col>
              <el-col :span="4" :offset="1"
                ><span style="line-height: 28px">公司名称：</span></el-col
              >
              <el-col :span="19" v-if="companyName" style="line-height: 28px">{{
                companyName
              }}</el-col>
              <el-col :span="12" v-else>
                <el-select
                  v-model="companyId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入公司字号筛选公司"
                  size="mini"
                  clearable
                  @change="handleCompanyChange"
                  :remote-method="remoteCompanyMethod"
                  :loading="loading"
                >
                  <el-option
                    v-for="company in companies"
                    :key="company.id"
                    :label="company.company_name"
                    :value="company.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="companyName">
          <el-card class="box-card" style="margin-bottom: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">确认材料</span>
              <el-popconfirm title="确认完成吗？" @onConfirm="handleStepOne">
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  plain
                  :disabled="oneAddData.is_finish === 2"
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <el-col :span="24" class="m-col">
              <el-tooltip class="item" effect="dark" content="材料来源" placement="top">
                <el-col :span="5" class="count_style">材料来源：</el-col>
              </el-tooltip>
              <el-col :span="19">
                <el-radio-group v-model="stepOne.type" size="mini">
                  <el-radio :label="1" border>内部交接</el-radio>
                  <el-radio :label="2" border>客户快递</el-radio>
                  <el-radio :label="3" border>其它方式</el-radio>
                </el-radio-group>
              </el-col>
            </el-col>
            <span v-if="stepOne.type === 2">
              <span class="m-col" style="color: red; opacity: 0.65"
                >*若暂无快递单号信息，可不填写快递单号，直接点击完成</span
              >
              <el-col :span="24" class="m-col">
                <el-tooltip class="item" effect="dark" content="快递单号" placement="top">
                  <el-col :span="5" class="count_style">快递公司：</el-col>
                </el-tooltip>
                <el-col :span="19">
                  <el-select
                    v-model="stepOne.exp_com"
                    placeholder="请选择快递公司"
                    size="mini"
                    clearable
                  >
                    <el-option value="SFEXPRESS" label="顺丰"></el-option>
                    <el-option value="STO" label="申通"></el-option>
                    <el-option value="YTO" label="圆通"></el-option>
                    <el-option value="ZTO" label="中通"></el-option>
                    <el-option value="HTKY" label="汇通"></el-option>
                    <el-option value="YUNDA" label="韵达"></el-option>
                    <el-option value="TTKDEX" label="天天"></el-option>
                    <el-option value="JD" label="京东快递"></el-option>
                    <el-option value="ZJS" label="宅急送"></el-option>
                    <el-option value="CHINAPOST" label="EMS"></el-option>
                    <el-option value="INTMAIL" label="EMS国际"></el-option>
                    <el-option value="DEPPON" label="德邦"></el-option>
                  </el-select>
                </el-col>
              </el-col>
              <el-col :span="24" class="m-col">
                <el-tooltip class="item" effect="dark" content="快递单号" placement="top">
                  <el-col :span="5" class="count_style">快递单号：</el-col>
                </el-tooltip>
                <el-col :span="19">
                  <el-input
                    v-model="stepOne.exp_num"
                    size="mini"
                    placeholder="请输入快递号码"
                  ></el-input>
                </el-col>
              </el-col>
              <el-col :span="24" class="m-col">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="收（发）件人手机号"
                  placement="top"
                >
                  <el-col :span="5" class="count_style">收（发）件人手机号：</el-col>
                </el-tooltip>
                <el-col :span="19">
                  <el-input
                    v-model="stepOne.exp_phone"
                    size="mini"
                    placeholder="请输入收（发）件人手机号"
                  ></el-input>
                </el-col>
              </el-col>
            </span>
            <el-col>
              <el-collapse v-model="collapseOne" accordion>
                <el-collapse-item title="详细信息">
                  <el-col :span="24">
                    <el-col :span="12">
                      <el-col :span="8">操作人员：</el-col>
                      <el-col :span="16">{{
                        oneAddData.admin ? oneAddData.admin.username : ""
                      }}</el-col>
                    </el-col>
                    <el-col :span="12">
                      <el-col :span="8">操作时间：</el-col>
                      <el-col :span="16">{{ oneAddData.created_at }}</el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="12">
                      <el-col :span="8">材料来源：</el-col>
                      <el-col :span="16">{{
                        oneAddData.type === 1
                          ? "内部交接"
                          : oneAddData.type === 2
                          ? "客户快递"
                          : oneAddData.type === 3
                          ? "其他方式"
                          : ""
                      }}</el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24" class="m-col">
                    <el-collapse v-model="collapseOneOne" accordion>
                      <el-collapse-item
                        title="快递信息"
                        v-if="oneAddData.express && oneAddData.express.content"
                      >
                        <div class="block">
                          <el-timeline>
                            <el-timeline-item
                              v-for="(item, index) in oneAddData.express.content"
                              :key="index"
                              :timestamp="item.time"
                            >
                              {{ item.status }}
                            </el-timeline-item>
                          </el-timeline>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </el-col>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
          <el-card class="box-card" style="margin-bottom: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">整理材料</span>
              <el-popconfirm title="确认完成吗？" @onConfirm="overStepTwo">
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  plain
                  :disabled="twoAddData.is_finish === 2"
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <el-col>
              <span style="color: red; opacity: 0.65"
                >*若无图片和文件上传，可整理完材料后直接点击完成</span
              >
              <el-form :model="twoForm" ref="twoForm" label-width="100px" size="mini">
                <el-card class="box-card m-col">
                  <el-upload
                    multiple
                    ref="upload"
                    action="#"
                    :limit="5"
                    :on-preview="handleLicensePreview"
                    :on-change="handleLicenseChange2"
                    :on-remove="handleLicenseRemove2"
                    :file-list="licenseList2"
                    accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                    list-type="file"
                    :auto-upload="false"
                  >
                    <el-link slot="trigger" type="primary" style="line-height: 28px"
                      >选择文件(最多可选择5个文件)</el-link
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      style="float: right"
                      @click="submitAddUpload('twoForm', 2)"
                      :disabled="twoAddData.is_finish === 2"
                      >上传文件</el-button
                    >
                  </el-upload>
                </el-card>
                <el-input
                  v-paste="handleParse2"
                  type="textarea"
                  placeholder="请点击此处，再粘贴复制的截图"
                />
              </el-form>
            </el-col>
            <el-col>
              <el-collapse v-model="collapseTwo" accordion>
                <el-collapse-item title="文件信息">
                  <el-row>
                    <el-col>
                      <el-col :span="24">
                        <el-col :span="12">
                          <el-col :span="8">操作人员：</el-col>
                          <el-col :span="16">{{
                            twoAddData.admin ? twoAddData.admin.username : ""
                          }}</el-col>
                        </el-col>
                        <el-col :span="12">
                          <el-col :span="8">操作时间：</el-col>
                          <el-col :span="16">{{ twoAddData.created_at }}</el-col>
                        </el-col>
                      </el-col>
                    </el-col>
                  </el-row>
                  <el-row
                    style="margin-bottom: 0; padding-bottom: 0"
                    v-if="twoAddData.images.length > 0"
                  >
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="twoAddData.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in twoAddData.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="twoAddData.images"
                          >
                          </el-image>
                        </el-row>
                        <div
                          style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center"
                        >
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, twoAddData.id, 2)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="twoAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row v-if="twoAddData.files.length > 0">
                    <el-divider content-position="left" v-if="twoAddData.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in twoAddData.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="
                              handleDeleteImage(file.file_url, twoAddData.id, 2)
                            "
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="twoAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
          <el-card class="box-card" style="margin-bottom: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">园区操作</span>
              <el-popconfirm
                title="确认完成吗？"
                @onConfirm="overThisTaxReg(threeAddData.id, 3)"
              >
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  plain
                  :disabled="threeAddData.is_finish === 2"
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <el-col :span="24" class="m-col">
              <el-tooltip class="item" effect="dark" content="材料来源" placement="top">
                <el-col :span="5" class="count_style">操作方式：</el-col>
              </el-tooltip>
              <el-col :span="19">
                <el-radio-group v-model="addForm.type" size="mini">
                  <el-radio :label="4" border>快递给园区</el-radio>
                  <el-radio :label="5" border>汇报给园区</el-radio>
                </el-radio-group>
              </el-col>
              <el-col class="m-col" v-if="addForm.type === 4">
                <el-col :span="24" class="m-col">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="快递单号"
                    placement="top"
                  >
                    <el-col :span="5" class="count_style">快递公司：</el-col>
                  </el-tooltip>
                  <el-col :span="19">
                    <el-select
                      v-model="addForm.exp_com"
                      placeholder="请选择快递公司"
                      size="mini"
                      clearable
                    >
                      <el-option value="SFEXPRESS" label="顺丰"></el-option>
                      <el-option value="STO" label="申通"></el-option>
                      <el-option value="YTO" label="圆通"></el-option>
                      <el-option value="ZTO" label="中通"></el-option>
                      <el-option value="HTKY" label="汇通"></el-option>
                      <el-option value="YUNDA" label="韵达"></el-option>
                      <el-option value="TTKDEX" label="天天"></el-option>
                      <el-option value="JD" label="京东快递"></el-option>
                      <el-option value="ZJS" label="宅急送"></el-option>
                      <el-option value="CHINAPOST" label="EMS"></el-option>
                      <el-option value="INTMAIL" label="EMS国际"></el-option>
                      <el-option value="DEPPON" label="德邦"></el-option>
                    </el-select>
                  </el-col>
                </el-col>
                <el-col :span="24" class="m-col">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="快递单号"
                    placement="top"
                  >
                    <el-col :span="5" class="count_style">快递单号：</el-col>
                  </el-tooltip>
                  <el-col :span="19">
                    <el-input
                      v-model="addForm.exp_num"
                      size="mini"
                      placeholder="请输入快递号码"
                    ></el-input>
                  </el-col>
                </el-col>
                <el-col :span="24" class="m-col">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="收（发）件人手机号"
                    placement="top"
                  >
                    <el-col :span="5" class="count_style">收（发）件人手机号：</el-col>
                  </el-tooltip>
                  <el-col :span="19">
                    <el-input
                      v-model="addForm.exp_phone"
                      size="mini"
                      placeholder="请输入收（发）件人手机号"
                    ></el-input>
                  </el-col>
                </el-col>
                <el-col :span="24">
                  <el-button
                    style="float: right"
                    type="primary"
                    size="mini"
                    @click="submitAddUpload('addForm', 3)"
                    :disabled="threeAddData.is_finish === 2"
                    >提交信息</el-button
                  >
                </el-col>
              </el-col>
              <el-col :span="24" class="m-col" v-if="addForm.type === 5">
                <el-form :model="addForm" ref="addForm" label-width="100px" size="mini">
                  <el-card class="box-card m-col">
                    <el-upload
                      multiple
                      ref="upload"
                      action="#"
                      :limit="5"
                      :on-preview="handleLicensePreview"
                      :on-change="handleLicenseChange1"
                      :on-remove="handleLicenseRemove1"
                      :file-list="licenseList1"
                      accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                      list-type="file"
                      :auto-upload="false"
                    >
                      <el-link slot="trigger" type="primary" style="line-height: 28px"
                        >选择文件(最多可选择5个文件)</el-link
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        style="float: right"
                        @click="submitAddUpload('addForm', 3)"
                        :disabled="threeAddData.is_finish === 2"
                        >上传文件</el-button
                      >
                    </el-upload>
                  </el-card>
                  <el-input
                    v-paste="handleParse1"
                    type="textarea"
                    placeholder="请点击此处，再粘贴复制的截图"
                  />
                </el-form>
              </el-col>
            </el-col>
            <el-col>
              <el-collapse v-model="collapseThree" accordion>
                <el-collapse-item title="快递或文件信息">
                  <el-row>
                    <el-col>
                      <el-col :span="24">
                        <el-col :span="12">
                          <el-col :span="8">操作人员：</el-col>
                          <el-col :span="16">{{
                            threeAddData.admin ? threeAddData.admin.username : ""
                          }}</el-col>
                        </el-col>
                        <el-col :span="12">
                          <el-col :span="8">操作时间：</el-col>
                          <el-col :span="16">{{ threeAddData.created_at }}</el-col>
                        </el-col>
                      </el-col>
                      <el-col :span="24">
                        <el-col :span="12">
                          <el-col :span="8">操作方式：</el-col>
                          <el-col :span="16">{{
                            threeAddData.type === 4
                              ? "快递给园区"
                              : threeAddData.type === 5
                              ? "汇报给园区"
                              : ""
                          }}</el-col>
                        </el-col>
                      </el-col>
                    </el-col>
                  </el-row>
                  <el-row
                    style="margin-bottom: 0; padding-bottom: 0"
                    v-if="threeAddData.images.length > 0"
                  >
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="threeAddData.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in threeAddData.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="threeAddData.images"
                          >
                          </el-image>
                        </el-row>
                        <div
                          style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center"
                        >
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, threeAddData.id, 3)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="threeAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row v-if="threeAddData.files.length > 0">
                    <el-divider
                      content-position="left"
                      v-if="threeAddData.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in threeAddData.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="
                              handleDeleteImage(file.file_url, threeAddData.id, 3)
                            "
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="threeAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                  <el-row v-if="threeAddData.express && threeAddData.express.content">
                    <el-col :span="24" class="m-col">
                      <el-collapse v-model="collapseThreeThree" accordion>
                        <el-collapse-item title="快递信息">
                          <div class="block">
                            <el-timeline>
                              <el-timeline-item
                                v-for="(item, index) in threeAddData.express.content"
                                :key="index"
                                :timestamp="item.time"
                              >
                                {{ item.status }}
                              </el-timeline-item>
                            </el-timeline>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
          <el-card class="box-card" style="margin-bottom: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">网厅申报</span>
              <el-popconfirm
                title="确认完成吗？"
                @onConfirm="overThisTaxReg(fourAddData.id, 4)"
              >
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  plain
                  :disabled="fourAddData.is_finish === 2"
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <el-col :span="24">
              <el-form :model="fourForm" ref="fourForm" label-width="100px" size="mini">
                <el-card class="box-card m-col">
                  <el-upload
                    multiple
                    ref="upload"
                    action="#"
                    :limit="5"
                    :on-preview="handleLicensePreview"
                    :on-change="handleLicenseChange3"
                    :on-remove="handleLicenseRemove3"
                    :file-list="licenseList3"
                    accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                    list-type="file"
                    :auto-upload="false"
                  >
                    <el-link slot="trigger" type="primary" style="line-height: 28px"
                      >选择文件(最多可选择5个文件)</el-link
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      style="float: right"
                      @click="submitAddUpload('fourForm', 4)"
                      >上传文件</el-button
                    >
                  </el-upload>
                </el-card>
                <el-input
                  v-paste="handleParse3"
                  type="textarea"
                  placeholder="请点击此处，再粘贴复制的截图"
                />
              </el-form>
            </el-col>
            <el-col>
              <el-collapse v-model="collapseFour" accordion>
                <el-collapse-item title="文件信息">
                  <el-row>
                    <el-col>
                      <el-col :span="24">
                        <el-col :span="12">
                          <el-col :span="8">操作人员：</el-col>
                          <el-col :span="16">{{
                            fourAddData.admin ? fourAddData.admin.username : ""
                          }}</el-col>
                        </el-col>
                        <el-col :span="12">
                          <el-col :span="8">操作时间：</el-col>
                          <el-col :span="16">{{ fourAddData.created_at }}</el-col>
                        </el-col>
                      </el-col>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="fourAddData.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in fourAddData.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="fourAddData.images"
                          >
                          </el-image>
                        </el-row>
                        <div
                          style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center"
                        >
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, fourAddData.id, 4)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="fourAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="fourAddData.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in fourAddData.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="
                              handleDeleteImage(file.file_url, fourAddData.id, 4)
                            "
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="fourAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
          <el-card class="box-card" style="margin-bottom: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">报到成功</span>
              <el-popconfirm
                title="确认完成吗？"
                @onConfirm="overThisTaxReg(fiveAddData.id, 5)"
              >
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  plain
                  :disabled="fiveAddData.is_finish === 2"
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <el-col :span="24">
              <el-form :model="fiveForm" ref="fiveForm" label-width="100px" size="mini">
                <el-card class="box-card m-col">
                  <el-upload
                    multiple
                    ref="upload"
                    action="#"
                    :limit="5"
                    :on-preview="handleLicensePreview"
                    :on-change="handleLicenseChange4"
                    :on-remove="handleLicenseRemove4"
                    :file-list="licenseList4"
                    accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                    list-type="file"
                    :auto-upload="false"
                  >
                    <el-link slot="trigger" type="primary" style="line-height: 28px"
                      >选择文件(最多可选择5个文件)</el-link
                    >
                  </el-upload>
                </el-card>
                <el-input
                  v-paste="handleParse4"
                  type="textarea"
                  placeholder="请点击此处，再粘贴复制的截图"
                />
              </el-form>
            </el-col>
            <el-col>
              <el-card style="margin-top: 15px">
                <el-divider content-position="left"
                  ><span class="top-line">税控托管信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="是否托管" placement="top">
                      <span class="count_style" style="display: inherit"
                        ><span style="color: red">*</span>是否托管：</span
                      >
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group v-model="fiveForm.is_trust" size="mini">
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <span v-if="fiveForm.is_trust === '是'">
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="购买发票：" placement="top">
                        <span class="count_style" style="display: inherit"
                          ><span style="color: red">*</span>购买发票：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group v-model="fiveForm.is_invoice_bill" size="mini">
                        <el-radio-button label="未知">未知</el-radio-button>
                        <el-radio-button label="否">否</el-radio-button>
                        <el-radio-button label="是">是</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="购买税控" placement="top">
                        <span class="count_style" style="display: inherit"
                          ><span style="color: red">*</span>购买税控：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group v-model="fiveForm.is_buy_tax" size="mini">
                        <el-radio-button label="未知">未知</el-radio-button>
                        <el-radio-button label="否">否</el-radio-button>
                        <el-radio-button label="是">是</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="建档位置" placement="top">
                        <span class="count_style" style="display: inherit"
                          ><span style="color: red">*</span>建档位置：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group v-model="fiveForm.filing_place" size="mini">
                        <el-radio-button label="区域">区域</el-radio-button>
                        <el-radio-button label="编号">编号</el-radio-button>
                        <el-radio-button label="所属电脑">所属电脑</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label"
                      ><span style="color: red">*</span>发票章：</el-col
                    >
                    <el-col :span="20" class="m-label">
                      <el-radio-group v-model="fiveForm.invoice_seal" size="mini">
                        <el-radio-button label="未知">未知</el-radio-button>
                        <el-radio-button label="我司保管">我司保管</el-radio-button>
                        <el-radio-button label="客户自管">客户自管</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="税控类型" placement="top">
                        <span class="count_style" style="display: inherit"
                          ><span style="color: red">*</span>税控类型：</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group v-model="fiveForm.tax_ctrl_type" size="mini">
                        <el-radio-button label="航天金税盘">航天金税盘</el-radio-button>
                        <el-radio-button label="百旺金税盘">百旺金税盘</el-radio-button>
                        <el-radio-button label="ukey">ukey</el-radio-button>
                        <el-radio-button label="凯盈云">凯盈云</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                </span>
                <el-divider content-position="left"
                  ><span class="top-line">税控托管信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">订单套餐：</el-col>
                  <el-col :span="7">
                    <el-select
                      :filterable="true"
                      v-model="fiveForm.order_combo"
                      placeholder="请选择订单套餐"
                      size="mini"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) in combos"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">单品类型：</el-col>
                  <el-col :span="7">
                    <el-select
                      multiple
                      collapse-tags
                      :popper-append-to-body="false"
                      :filterable="true"
                      v-model="fiveForm.order_item"
                      placeholder="请选择订单套餐"
                      size="mini"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) in items"
                        :key="index"
                        :label="item.item_name"
                        :value="item.item_id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label"
                    ><span style="color: red">*</span>执照授权：</el-col
                  >
                  <el-col :span="7" class="m-label">
                    <el-radio-group v-model="fiveForm.license_auth" size="mini">
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label"
                    ><span style="color: red">*</span>财税对接</el-col
                  >
                  <el-col :span="7" class="m-label">
                    <el-radio-group v-model="fiveForm.finance_buut_join" size="mini">
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="购买UKEY：" placement="top">
                      <span class="count_style" style="display: inherit"
                        ><span style="color: red">*</span>购买UKEY：</span
                      >
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group v-model="fiveForm.is_ukey" size="mini">
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label"
                    ><span style="color: red">*</span>基本户信息表：</el-col
                  >
                  <el-col :span="7" class="m-label">
                    <el-radio-group v-model="fiveForm.triple_agreement" size="mini">
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="无">无</el-radio-button>
                      <el-radio-button label="有">有</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label"
                    ><span style="color: red">*</span>社保：</el-col
                  >
                  <el-col :span="7" class="m-label">
                    <el-radio-group v-model="fiveForm.social_security" size="mini">
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="无">无</el-radio-button>
                      <el-radio-button label="有">有</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label"
                    ><span style="color: red">*</span>公积金：</el-col
                  >
                  <el-col :span="7" class="m-label">
                    <el-radio-group v-model="fiveForm.accumula_fund" size="mini">
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="无">无</el-radio-button>
                      <el-radio-button label="有">有</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label"
                    ><span style="color: red">*</span>CA开户：</el-col
                  >
                  <el-col :span="20" class="m-label">
                    <el-radio-group v-model="fiveForm.open_account" size="mini">
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                      <el-radio-button label="执照失效">执照失效</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">税种规模</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label"
                    ><span style="color: red">*</span>纳税规模：</el-col
                  >
                  <el-col :span="7" class="m-label">
                    <el-radio-group v-model="fiveForm.tax_scale" size="mini">
                      <el-radio-button label="1">小规模</el-radio-button>
                      <el-radio-button label="2">一般纳税人</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label"
                    ><span style="color: red">*</span>核定税种：</el-col
                  >
                  <el-col :span="7" class="m-label">
                    <el-select
                      multiple
                      collapse-tags
                      :popper-append-to-body="false"
                      :filterable="true"
                      v-model="fiveForm.check_tax_cate"
                      placeholder="请选择税种"
                      size="mini"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) in tax_cates"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label"
                    ><span style="color: red">*</span>征收方式：</el-col
                  >
                  <el-col :span="20" class="m-label">
                    <el-radio-group v-model="fiveForm.collect_type" size="mini">
                      <el-radio-button label="查账征收">查账征收</el-radio-button>
                      <el-radio-button label="核定征收">核定征收</el-radio-button>
                      <el-radio-button label="个体户">个体户</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">法人信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">法人姓名：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiveForm.legal_name"
                      size="mini"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">法人手机：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiveForm.legal_phone"
                      size="mini"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="法人身份证" placement="top">
                      <span class="count_style" style="display: inherit"
                        >法人身份证：</span
                      >
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiveForm.legal_id_number"
                      size="mini"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="网厅财务负责人" placement="top">
                      <span class="count_style" style="display: inherit"
                        >网厅财务负责人：</span
                      >
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiveForm.net_finance_person"
                      size="mini"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row class="tr">
                  <el-button
                    type="primary"
                    size="mini"
                    style="float: right"
                    @click="submitAddUpload('fiveForm', 5)"
                    :disabled="fiveAddData.is_finish === 2"
                    >提交</el-button
                  >
                </el-row>
              </el-card>
            </el-col>
            <el-col>
              <el-collapse v-model="collapseFive" accordion>
                <el-collapse-item title="文件信息">
                  <el-row>
                    <el-col>
                      <el-col :span="24">
                        <el-col :span="12">
                          <el-col :span="8">操作人员：</el-col>
                          <el-col :span="16">{{
                            fiveAddData.admin ? fiveAddData.admin.username : ""
                          }}</el-col>
                        </el-col>
                        <el-col :span="12">
                          <el-col :span="8">操作时间：</el-col>
                          <el-col :span="16">{{ fiveAddData.created_at }}</el-col>
                        </el-col>
                      </el-col>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="fiveAddData.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in fiveAddData.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="fiveAddData.images"
                          >
                          </el-image>
                        </el-row>
                        <div
                          style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center"
                        >
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, fiveAddData.id, 5)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="fiveAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="fiveAddData.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in fiveAddData.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="
                              handleDeleteImage(file.file_url, fiveAddData.id, 5)
                            "
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="fiveAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
          <el-card class="box-card" style="margin-bottom: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">客户配合授权</span>
              <el-popconfirm
                title="确认完成吗？"
                @onConfirm="overThisTaxReg(sixAddData.id, 6)"
              >
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  plain
                  :disabled="sixAddData.is_finish === 2"
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <el-col :span="24">
              <el-form :model="sixForm" ref="sixForm" label-width="100px" size="mini">
                <el-card class="box-card m-col">
                  <el-upload
                    multiple
                    ref="upload"
                    action="#"
                    :limit="5"
                    :on-preview="handleLicensePreview"
                    :on-change="handleLicenseChange5"
                    :on-remove="handleLicenseRemove5"
                    :file-list="licenseList5"
                    accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                    list-type="file"
                    :auto-upload="false"
                  >
                    <el-link slot="trigger" type="primary" style="line-height: 28px"
                      >选择文件(最多可选择5个文件)</el-link
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      style="float: right"
                      @click="submitAddUpload('sixForm', 6)"
                      :disabled="sixAddData.is_finish === 2"
                      >上传文件</el-button
                    >
                  </el-upload>
                </el-card>
                <el-input
                  v-paste="handleParse5"
                  type="textarea"
                  placeholder="请点击此处，再粘贴复制的截图"
                />
              </el-form>
            </el-col>
            <el-col>
              <el-collapse v-model="collapseSix" accordion>
                <el-collapse-item title="文件信息">
                  <el-row>
                    <el-col>
                      <el-col :span="24">
                        <el-col :span="12">
                          <el-col :span="8">操作人员：</el-col>
                          <el-col :span="16">{{
                            sixAddData.admin ? sixAddData.admin.username : ""
                          }}</el-col>
                        </el-col>
                        <el-col :span="12">
                          <el-col :span="8">操作时间：</el-col>
                          <el-col :span="16">{{ sixAddData.created_at }}</el-col>
                        </el-col>
                      </el-col>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="sixAddData.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in sixAddData.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="sixAddData.images"
                          >
                          </el-image>
                        </el-row>
                        <div
                          style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center"
                        >
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, sixAddData.id, 6)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="sixAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="sixAddData.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in sixAddData.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="
                              handleDeleteImage(file.file_url, sixAddData.id, 6)
                            "
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="sixAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
          <el-card class="box-card" style="margin-bottom: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">天眼查完成截图</span>
            </div>
            <el-col :span="24">
              <el-form :model="sevenForm" ref="sevenForm" label-width="100px" size="mini">
                <el-card class="box-card m-col">
                  <el-upload
                    multiple
                    ref="upload"
                    action="#"
                    :limit="5"
                    :on-preview="handleLicensePreview"
                    :on-change="handleLicenseChange6"
                    :on-remove="handleLicenseRemove6"
                    :file-list="licenseList6"
                    accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                    list-type="file"
                    :auto-upload="false"
                  >
                    <el-link slot="trigger" type="primary" style="line-height: 28px"
                      >选择文件(最多可选择5个文件)</el-link
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      style="float: right"
                      @click="submitAddUpload('sevenForm', 7)"
                      :disabled="sevenAddData.is_finish === 2"
                      >上传文件</el-button
                    >
                  </el-upload>
                </el-card>
                <el-input
                  v-paste="handleParse6"
                  type="textarea"
                  placeholder="请点击此处，再粘贴复制的截图"
                />
              </el-form>
            </el-col>
            <el-col>
              <el-collapse v-model="collapseSeven" accordion>
                <el-collapse-item title="文件信息">
                  <el-row>
                    <el-col>
                      <el-col :span="24">
                        <el-col :span="12">
                          <el-col :span="8">操作人员：</el-col>
                          <el-col :span="16">{{
                            sevenAddData.admin ? sevenAddData.admin.username : ""
                          }}</el-col>
                        </el-col>
                        <el-col :span="12">
                          <el-col :span="8">操作时间：</el-col>
                          <el-col :span="16">{{ sevenAddData.created_at }}</el-col>
                        </el-col>
                      </el-col>
                    </el-col>
                  </el-row>
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="sevenAddData.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in sevenAddData.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="sevenAddData.images"
                          >
                          </el-image>
                        </el-row>
                        <div
                          style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center"
                        >
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, sevenAddData.id, 6)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="sevenAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="sevenAddData.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in sevenAddData.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="
                              handleDeleteImage(file.file_url, sevenAddData.id, 6)
                            "
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="sevenAddData.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
    :title="'订单信息： ' + orderNum"
      :visible.sync="orderInfoVisible"
      direction="rtl"
      custom-class="AIdrawer"
      size="50%"
      :before-close="handleOrderInfoClose"
    >
    <div class="drawer-title" slot="title">订单信息： {{ orderNum }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" :checkType="serviceCheckType"></order-info>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import OrderInfo from "common/OrderInfo";
import CompanyInfo from "common/CompanyInfo";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";

export default {
  name: "TaxReg",
  components: {
    CallLogs,
    CompanyInfo,
    OrderInfo,
    WxWorkChat,
    PhoneCom
  },
  data() {
    return {
      addtionData: { value: "自助下单", label: "自助下单" },
      wxChatDrawer: false,
      serviceCheckType: this.$feedBackConfig.order_service,
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      editDrawer: false,
      loading: false,
      callLogsDrawer: false,
      companyInfoDrawer: false,
      searchVisible: false,
      activeName: "info",
      isOvered: false,
      oneOvered: false,
      orderId: null,
      orderNum: "",
      winIndex: null,
      companyId: null,
      companyInfoId: null,
      companyName: "",
      typeArr: [],
      logs: [],
      users: [],
      parks: [],
      items: [],
      combos: [],
      tax_cates: [],
      regTypes: [],
      features: [],
      orders: [],
      companies: [],
      orderNums: [],
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      licenseList1: [],
      licenseList2: [],
      licenseList3: [],
      licenseList4: [],
      licenseList5: [],
      licenseList6: [],
      formData: null,
      inputSize: "small",
      collapseOne: ["1"],
      collapseTwo: ["1"],
      collapseThree: ["1"],
      collapseFour: ["1"],
      collapseFive: ["1"],
      collapseSix: ["1"],
      collapseSeven: ["1"],
      collapseOneOne: ["1"],
      collapseThreeThree: ["1"],
      fromOptions: [],
      addForm: {
        index: null,
        order_id: "",
        exp_com: "",
        exp_num: "",
        exp_phone: "",
        type: "",
      },
      searchArr: {
        id: null,
        status: "",
        step: "",
        service_status: "",
        consultant: null,
        feature: null,
        actual_reg_type: null,
        operator: null,
        platform: null,
        park: null,
        company_id: null,
      },
      twoForm: {
        index: null,
        order_id: "",
      },
      fourForm: {
        index: null,
        order_id: "",
      },
      fiveForm: {
        index: null,
        cid: null,
        order_id: "",
        is_trust: null,
        is_invoice_bill: "",
        is_buy_tax: "",
        tax_ctrl_type: "",
        invoice_seal: "",
        filing_place: "",
        order_combo: "",
        order_item: [],
        license_auth: "",
        finance_buut_join: "",
        is_ukey: "",
        triple_agreement: "",
        social_security: "",
        accumula_fund: "",
        open_account: "",
        tax_scale: "",
        check_tax_cate: [],
        collect_type: "",
        legal_name: "",
        legal_phone: "",
        legal_id_number: "",
        net_finance_person: "",
      },
      sixForm: {
        index: null,
        order_id: "",
      },
      sevenForm: {
        index: null,
        order_id: "",
      },
      stepOne: {
        type: null,
        exp_num: "",
        exp_phone: "",
        exp_com: "",
      },
      stepThree: {
        type: null,
      },
      oneAddData: {
        id: null,
        order_id: null,
        admin: null,
        is_finish: "",
        express: null,
        type: "",
        created_at: "",
      },
      twoAddData: {
        id: null,
        order_id: null,
        admin: null,
        is_finish: "",
        images: [],
        files: [],
        type: "",
        created_at: "",
      },
      threeAddData: {
        id: null,
        order_id: null,
        admin: null,
        is_finish: "",
        images: [],
        files: [],
        express: null,
        type: "",
        created_at: "",
      },
      fourAddData: {
        id: null,
        order_id: null,
        admin: null,
        is_finish: "",
        images: [],
        files: [],
        type: "",
        created_at: "",
      },
      fiveAddData: {
        id: null,
        order_id: null,
        admin: null,
        is_finish: "",
        images: [],
        files: [],
        type: "",
        created_at: "",
      },
      sixAddData: {
        id: null,
        order_id: null,
        admin: null,
        is_finish: "",
        images: [],
        files: [],
        type: "",
        created_at: "",
      },
      sevenAddData: {
        id: null,
        order_id: null,
        admin: null,
        is_finish: "",
        images: [],
        files: [],
        type: "",
        created_at: "",
      },
      orderInfoVisible: false,
      orderInfoId: null,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      searchLoading: false,
      searchCompanies: [],
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    usersConvert() {
      return [this.addtionData, ...this.users];
    },
  },
  methods: {
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handelGetOrders() {
      this.$axios
        .get("/api/tax_reg?page=" + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders = data.data.orders.data;
            this.orderRegs = data.data.orderRegs;
            this.users = data.data.users;
            this.parks = data.data.parks;
            this.items = data.data.items;
            this.combos = data.data.combos;
            this.tax_cates = data.data.tax_cates;
            this.regTypes = data.data.regTypes;
            this.features = data.data.features;
            this.pageOption.total = data.data.orders.total;
          }
        });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        if (row.customer_phone) this.callPhone1.push(row.customer_phone);
        if (row.corporate_phone) this.callPhone2.push(row.corporate_phone);
        if (row.company_obj) {
          this.company = row.company_obj.company_name;
          if (row.company_obj.user) this.callPhone.push(row.company_obj.user.phone);
          if (row.company_obj.docking_phone)
            this.callPhone3.push(row.company_obj.docking_phone);
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleCompanyChange() {
      this.$axios
        .post("/api/industry/change/save_company/" + this.orderId, {
          cid: this.companyId,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.companyName = data.data.cname;
            this.orders[this.winIndex].company_id = this.companyId;
            this.orders[this.winIndex].company = data.data.cname;
            this.$message.success(data.msg);
          }
        });
    },
    handleLicensePreview(file) {},
    handleLicenseChange1(file, fileList) {
      this.licenseList1 = fileList;
    },
    handleLicenseChange2(file, fileList) {
      this.licenseList2 = fileList;
    },
    handleLicenseChange3(file, fileList) {
      this.licenseList3 = fileList;
    },
    handleLicenseChange4(file, fileList) {
      this.licenseList4 = fileList;
    },
    handleLicenseChange5(file, fileList) {
      this.licenseList5 = fileList;
    },
    handleLicenseChange6(file, fileList) {
      this.licenseList6 = fileList;
    },
    handleLicenseRemove1(file, fileList) {
      this.licenseList1 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList1.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove2(file, fileList) {
      this.licenseList2 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList2.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.twoForm) {
        this.formData.append(key, this.twoForm[key]);
      }
    },
    handleLicenseRemove3(file, fileList) {
      this.licenseList3 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList3.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.fourForm) {
        this.formData.append(key, this.fourForm[key]);
      }
    },
    handleLicenseRemove4(file, fileList) {
      this.licenseList4 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList4.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.fiveForm) {
        this.formData.append(key, this.fiveForm[key]);
      }
    },
    handleLicenseRemove5(file, fileList) {
      this.licenseList5 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList5.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.sixForm) {
        this.formData.append(key, this.sixForm[key]);
      }
    },
    handleLicenseRemove6(file, fileList) {
      this.licenseList6 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList6.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.sixForm) {
        this.formData.append(key, this.sixForm[key]);
      }
    },
    handleParse1(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList1.length < 5) {
            that.licenseList1.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse2(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList2.length < 5) {
            that.licenseList2.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse3(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList3.length < 5) {
            that.licenseList3.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse4(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList4.length < 5) {
            that.licenseList4.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse5(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList5.length < 5) {
            that.licenseList5.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse6(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList6.length < 5) {
            that.licenseList6.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload(refs, step) {
      if (this.licenseList2.length === 0 && step === 2) {
        this.$message.error("请选择办理文件或图片");
        return;
      }
      if (step === 3) {
        if (this.addForm.type === 4) {
          if (!this.addForm.exp_com) {
            this.$message.error("请选择快递公司");
            return;
          }
          if (!this.addForm.exp_num) {
            this.$message.error("请填写快递单号");
            return;
          }
          if (!this.addForm.exp_phone) {
            this.$message.error("请填写收（发）件人的手机号码");
            return;
          }
        }
        if (this.addForm === 5) {
          if (this.licenseList1.length === 0) {
            this.$message.error("请选择办理文件或图片");
            return;
          }
        }
      }
      if (this.licenseList3.length === 0 && step === 4) {
        this.$message.error("请选择办理文件或图片");
        return;
      }
      if (step === 5) {
        if (this.licenseList4.length === 0) {
          this.$message.error("请选择办理文件或图片");
          return;
        }
        if (!this.fiveForm.is_trust) {
          this.$message.error("请选择是否托管");
          return;
        }
        if (this.fiveForm.is_trust === "是") {
          if (!this.fiveForm.is_invoice_bill) {
            this.$message.error("请选择是否购买发票");
            return;
          }
          if (!this.fiveForm.is_buy_tax) {
            this.$message.error("请选择是否购买税控");
            return;
          }
          if (!this.fiveForm.filing_place) {
            this.$message.error("请选择建档位置");
            return;
          }
          if (!this.fiveForm.invoice_seal) {
            this.$message.error("请选择发票章");
            return;
          }
          if (!this.fiveForm.tax_ctrl_type) {
            this.$message.error("请选择税控类型");
            return;
          }
        }
        if (!this.fiveForm.license_auth) {
          this.$message.error("请选择执照授权");
          return;
        }
        if (!this.fiveForm.finance_buut_join) {
          this.$message.error("请选择财税对接");
          return;
        }
        if (!this.fiveForm.is_ukey) {
          this.$message.error("请选择是否购买UKEY");
          return;
        }
        if (!this.fiveForm.triple_agreement) {
          this.$message.error("请选择基本户信息表");
          return;
        }
        if (!this.fiveForm.social_security) {
          this.$message.error("请选择社保");
          return;
        }
        if (!this.fiveForm.accumula_fund) {
          this.$message.error("请选择公积金");
          return;
        }
        if (!this.fiveForm.open_account) {
          this.$message.error("请选择CA开户");
          return;
        }
        if (!this.fiveForm.tax_scale) {
          this.$message.error("请选择纳税规模");
          return;
        }
        if (!this.fiveForm.check_tax_cate.length) {
          this.$message.error("请选择核定税种");
          return;
        }
        if (!this.fiveForm.collect_type) {
          this.$message.error("请选择征收方式");
          return;
        }
      }
      if (this.licenseList5.length === 0 && step === 6) {
        this.$message.error("请选择办理文件或图片");
        return;
      }
      if (this.licenseList6.length === 0 && step === 7) {
        this.$message.error("请选择办理文件或图片");
        return;
      }
      this.formData = null;
      this.formData = new FormData();
      let route = "";
      if (step === 2) {
        route = "step_two";
        this.licenseList2.forEach((file) => this.formData.append("file[]", file.raw));
        this.formData.append("step", step);
        for (let key in this.towForm) {
          this.formData.append(key, this.towForm[key]);
        }
      }
      if (step === 3) {
        route = "step_three";
        this.licenseList1.forEach((file) => this.formData.append("file[]", file.raw));
        this.formData.append("step", step);
        for (let key in this.addForm) {
          this.formData.append(key, this.addForm[key]);
        }
      }
      if (step === 4) {
        route = "step_four";
        this.licenseList3.forEach((file) => this.formData.append("file[]", file.raw));
        this.formData.append("step", step);
        for (let key in this.fourForm) {
          this.formData.append(key, this.fourForm[key]);
        }
      }
      if (step === 5) {
        route = "step_four";
        this.licenseList4.forEach((file) => this.formData.append("file[]", file.raw));
        this.formData.append("step", step);
        for (let key in this.fiveForm) {
          this.formData.append(key, this.fiveForm[key]);
        }
      }
      if (step === 6) {
        route = "step_four";
        this.licenseList5.forEach((file) => this.formData.append("file[]", file.raw));
        this.formData.append("step", step);
        for (let key in this.sixForm) {
          this.formData.append(key, this.sixForm[key]);
        }
      }
      if (step === 7) {
        route = "step_four";
        this.licenseList6.forEach((file) => this.formData.append("file[]", file.raw));
        this.formData.append("step", step);
        for (let key in this.sevenForm) {
          this.formData.append(key, this.sevenForm[key]);
        }
      }
      this.$axios
        .post("/api/tax_reg/" + route + "/" + this.orderId, this.formData)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            if (step === 2) {
              this.orders[this.winIndex].step_two = data.data;
              this.setStepTwo(data.data);
              this.licenseList2 = [];
            }
            if (step === 3) {
              this.orders[this.winIndex].step_three = data.data;
              this.setStepThree(data.data);
              this.licenseList1 = [];
              this.addForm.type = null;
              this.addForm.exp_com = "";
              this.addForm.exp_num = "";
              this.addForm.exp_phone = "";
            }
            if (step === 4) {
              this.orders[this.winIndex].step_four = data.data.record;
              this.setStepFour(data.data.record);
              this.setFinTable(data.data.finTable);
              this.licenseList3 = [];
            }
            if (step === 5) {
              this.orders[this.winIndex].step_five = data.data.record;
              this.setStepFive(data.data.record);
              this.licenseList4 = [];
            }
            if (step === 6) {
              this.orders[this.winIndex].step_six = data.data.record;
              this.setStepSix(data.data.record);
              this.licenseList5 = [];
            }
            if (step === 7) {
              this.orders[this.winIndex].step_seven = data.data.record;
              this.setStepSeven(data.data.record);
              this.licenseList6 = [];
            }
            this.formData = null;
            this.$refs[refs].resetFields();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    setFinTable(row) {
      this.fiveForm.cid = row.company_id;
      this.fiveForm.is_trust = row.is_trust;
      this.fiveForm.is_invoice_bill = row.is_invoice_bill;
      this.fiveForm.is_buy_tax = row.is_buy_tax;
      this.fiveForm.tax_ctrl_type = row.tax_ctrl_type;
      this.fiveForm.invoice_seal = row.invoice_seal;
      this.fiveForm.filing_place = row.filing_place;
      this.fiveForm.order_combo = row.order_combo;
      this.fiveForm.order_item = [];
      this.fiveForm.license_auth = row.license_auth;
      this.fiveForm.finance_buut_join = row.finance_buut_join;
      this.fiveForm.is_ukey = row.is_ukey;
      this.fiveForm.triple_agreement = row.triple_agreement;
      this.fiveForm.social_security = row.social_security;
      this.fiveForm.accumula_fund = row.accumula_fund;
      this.fiveForm.open_account = row.open_account;
      this.fiveForm.tax_scale = row.tax_scale;
      this.fiveForm.check_tax_cate = [];
      this.fiveForm.collect_type = row.collect_type;
      this.fiveForm.legal_name = row.legal_name;
      this.fiveForm.legal_phone = row.legal_phone;
      this.fiveForm.legal_id_number = row.legal_id_number;
    },
    handleStepOne() {
      if (!this.stepOne.type) {
        this.$message.error("请选择资料类型");
        return false;
      }
      this.$axios
        .post("/api/tax_reg/step_one/" + this.orderId, this.stepOne)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders[this.winIndex].step_one = data.data;
            this.oneAddData.id = data.data.id;
            this.oneAddData.order_id = data.data.order_id;
            this.oneAddData.type = data.data.type;
            this.oneAddData.is_finish = data.data.is_finish;
            this.oneAddData.admin = data.data.admin;
            this.oneAddData.created_at = data.data.created_at;
            this.oneAddData.express = data.data.express;
            this.stepOne.type = null;
            this.stepOne.exp_com = "";
            this.stepOne.exp_num = "";
            this.stepOne.exp_phone = "";
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleEditOpen(index, row) {
      this.orderId = row.id;
      this.winIndex = index;
      this.orderNum = row.order_num;
      this.companyName = row.company;
      this.fiveForm.cid = row.company_id;
      this.editDrawer = true;
      if (row.step_one) {
        this.setStepOne(row.step_one);
      }
      if (row.step_two) {
        this.setStepTwo(row.step_two);
      }
      if (row.step_three) {
        this.setStepThree(row.step_three);
      }
      if (row.step_four) {
        this.setStepFour(row.step_four);
      }
      if (row.step_five) {
        this.setStepFive(row.step_five);
      }
      if (row.step_six) {
        this.setStepSix(row.step_six);
      }
      if (row.step_seven) {
        this.setStepSeven(row.step_seven);
      }
    },
    setStepOne(data) {
      this.oneAddData.id = data.id;
      this.oneAddData.order_id = data.order_id;
      this.oneAddData.type = data.type;
      this.oneAddData.is_finish = data.is_finish;
      this.oneAddData.admin = data.admin;
      this.oneAddData.created_at = data.created_at;
      if (data.express && data.express.status === 0) {
        this.oneAddData.express = this.getExpressByExpId(data.id, data.order_id);
      } else {
        this.oneAddData.express = data.express;
      }
    },
    setStepTwo(data) {
      this.twoAddData.id = data.id;
      this.twoAddData.order_id = data.order_id;
      this.twoAddData.type = data.type;
      this.twoAddData.is_finish = data.is_finish;
      this.twoAddData.admin = data.admin;
      this.twoAddData.created_at = data.created_at;
      this.twoAddData.files = data.files;
      if (data.images.length > 0) {
        this.twoAddData.images = [];
        for (let key in data.images) {
          this.twoAddData.images.push(data.images[key].image_url);
        }
      }
    },
    setStepThree(data) {
      this.threeAddData.id = data.id;
      this.threeAddData.order_id = data.order_id;
      this.threeAddData.type = data.type;
      this.threeAddData.is_finish = data.is_finish;
      this.threeAddData.admin = data.admin;
      this.threeAddData.created_at = data.created_at;
      this.threeAddData.files = data.files;
      if (data.images.length > 0) {
        this.threeAddData.images = [];
        for (let key in data.images) {
          this.threeAddData.images.push(data.images[key].image_url);
        }
      }
      if (data.express && data.express.status === 0) {
        this.threeAddData.express = this.getExpressByExpId(data.id, data.order_id);
      } else {
        this.threeAddData.express = data.express;
      }
    },
    setStepFour(data) {
      this.fourAddData.id = data.id;
      this.fourAddData.order_id = data.order_id;
      this.fourAddData.type = data.type;
      this.fourAddData.is_finish = data.is_finish;
      this.fourAddData.admin = data.admin;
      this.fourAddData.created_at = data.created_at;
      this.fourAddData.files = data.files;
      if (data.images.length > 0) {
        this.fourAddData.images = [];
        for (let key in data.images) {
          this.fourAddData.images.push(data.images[key].image_url);
        }
      }
    },
    setStepFive(data) {
      this.fiveAddData.id = data.id;
      this.fiveAddData.order_id = data.order_id;
      this.fiveAddData.type = data.type;
      this.fiveAddData.is_finish = data.is_finish;
      this.fiveAddData.admin = data.admin;
      this.fiveAddData.created_at = data.created_at;
      this.fiveAddData.files = data.files;
      if (data.images.length > 0) {
        this.fiveAddData.images = [];
        for (let key in data.images) {
          this.fiveAddData.images.push(data.images[key].image_url);
        }
      }
    },
    setStepSix(data) {
      this.sixAddData.id = data.id;
      this.sixAddData.order_id = data.order_id;
      this.sixAddData.type = data.type;
      this.sixAddData.is_finish = data.is_finish;
      this.sixAddData.admin = data.admin;
      this.sixAddData.created_at = data.created_at;
      this.sixAddData.files = data.files;
      if (data.images.length > 0) {
        this.sixAddData.images = [];
        for (let key in data.images) {
          this.sixAddData.images.push(data.images[key].image_url);
        }
      }
    },
    setStepSeven(data) {
      this.sevenAddData.id = data.id;
      this.sevenAddData.order_id = data.order_id;
      this.sevenAddData.type = data.type;
      this.sevenAddData.is_finish = data.is_finish;
      this.sevenAddData.admin = data.admin;
      this.sevenAddData.created_at = data.created_at;
      this.sevenAddData.files = data.files;
      if (data.images.length > 0) {
        this.sevenAddData.images = [];
        for (let key in data.images) {
          this.sevenAddData.images.push(data.images[key].image_url);
        }
      }
    },
    getExpressByExpId(id, oid) {
      this.$axios.get("/api/tax_reg/express/" + id + "/" + oid).then((res) => {
        const { data } = res;
        return data.data.express;
      });
    },
    downloadFile(url) {
      window.open(url);
    },
    handleDeleteImage(path, rid, step) {
      this.$axios
        .post("/api/tax_reg/delete", { path: path, oid: this.orderId, rid: rid })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            if (step === 2) {
              this.orders[this.winIndex].step_two = data.data;
              this.setStepTwo(data.data);
            }
            if (step === 3) {
              this.orders[this.winIndex].step_three = data.data;
              this.setStepThree(data.data);
            }
            if (step === 4) {
              this.orders[this.winIndex].step_four = data.data;
              this.setStepFour(data.data);
            }
            if (step === 5) {
              this.orders[this.winIndex].step_five = data.data;
              this.setStepFive(data.data);
            }
            if (step === 6) {
              this.orders[this.winIndex].step_six = data.data;
              this.setStepSix(data.data);
            }
            if (step === 7) {
              this.orders[this.winIndex].step_seven = data.data;
              this.setStepSeven(data.data);
            }
            this.$message.success(data.msg);
          }
        });
    },
    overThisTaxReg(id, step) {
      this.$axios.post("/api/tax_reg/over/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          if (step === 2) {
            this.twoAddData.is_finish = 2;
            this.orders[this.winIndex].step_two.is_finish = 2;
          }
          if (step === 3) {
            this.threeAddData.is_finish = 2;
            this.orders[this.winIndex].step_three.is_finish = 2;
          }
          if (step === 4) {
            this.fourAddData.is_finish = 2;
            this.orders[this.winIndex].step_four.is_finish = 2;
          }
          if (step === 5) {
            this.fiveAddData.is_finish = 2;
            this.orders[this.winIndex].step_five.is_finish = 2;
          }
          if (step === 6) {
            this.sixAddData.is_finish = 2;
            this.orders[this.winIndex].step_six.is_finish = 2;
          }
          if (step === 7) {
            this.sevenAddData.is_finish = 2;
            this.orders[this.winIndex].step_seven.is_finish = 2;
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    overStepTwo() {
      this.$axios.post("/api/tax_reg/two_over/" + this.orderId).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orders[this.winIndex].step_two = data.data;
          this.setStepTwo(data.data);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchOrders(query);
        }, 200);
      } else {
        this.orderNums = [];
      }
    },
    searchOrders(query) {
      this.$axios.get("/api/admin/searchOrders?num=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orderNums = data.data.orderNum;
        }
      });
    },
    handleOrderChange() {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    handleOrderInfo(orderId, order_num) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
        this.orderNum = order_num;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    handleClearList() {
      this.companyName = "";
      this.companyId = null;
      this.orderId = null;
      this.winIndex = null;
      this.editDrawer = false;
      this.licenseList1 = [];
      this.licenseList2 = [];
      this.formData = null;
      this.addForm.index = null;
      this.addForm.order_id = null;
      this.addForm.type = "";
      this.twoForm.index = null;
      this.twoForm.order_id = null;
      this.stepOne.type = null;
      this.stepOne.exp_num = "";
      this.stepOne.exp_phone = "";
      this.stepThree.type = null;
      this.oneAddData.id = null;
      this.oneAddData.order_id = null;
      this.oneAddData.type = "";
      this.oneAddData.is_finish = "";
      this.oneAddData.created_at = "";
      this.oneAddData.admin = null;
      this.oneAddData.express = null;
      this.twoAddData.id = null;
      this.twoAddData.order_id = null;
      this.twoAddData.type = "";
      this.twoAddData.is_finish = "";
      this.twoAddData.created_at = "";
      this.twoAddData.admin = null;
      this.twoAddData.express = null;
      this.twoAddData.images = [];
      this.twoAddData.files = [];
      this.threeAddData.id = null;
      this.threeAddData.order_id = null;
      this.threeAddData.type = "";
      this.threeAddData.is_finish = "";
      this.threeAddData.created_at = "";
      this.threeAddData.admin = null;
      this.threeAddData.express = null;
      this.threeAddData.images = [];
      this.threeAddData.files = [];
      this.fourAddData.id = null;
      this.fourAddData.order_id = null;
      this.fourAddData.type = "";
      this.fourAddData.is_finish = "";
      this.fourAddData.created_at = "";
      this.fourAddData.admin = null;
      this.fourAddData.express = null;
      this.fourAddData.images = [];
      this.fourAddData.files = [];
      this.fiveAddData.id = null;
      this.fiveAddData.order_id = null;
      this.fiveAddData.type = "";
      this.fiveAddData.is_finish = "";
      this.fiveAddData.created_at = "";
      this.fiveAddData.admin = null;
      this.fiveAddData.express = null;
      this.fiveAddData.images = [];
      this.fiveAddData.files = [];
      this.sixAddData.id = null;
      this.sixAddData.order_id = null;
      this.sixAddData.type = "";
      this.sixAddData.is_finish = "";
      this.sixAddData.created_at = "";
      this.sixAddData.admin = null;
      this.sixAddData.express = null;
      this.sixAddData.images = [];
      this.sixAddData.files = [];
      this.sevenAddData.id = null;
      this.sevenAddData.order_id = null;
      this.sevenAddData.type = "";
      this.sevenAddData.is_finish = "";
      this.sevenAddData.created_at = "";
      this.sevenAddData.admin = null;
      this.sevenAddData.express = null;
      this.sevenAddData.images = [];
      this.sevenAddData.files = [];
      this.fiveForm.cid = null;
      this.fiveForm.is_trust = null;
      this.fiveForm.is_invoice_bill = "";
      this.fiveForm.is_buy_tax = "";
      this.fiveForm.tax_ctrl_type = "";
      this.fiveForm.invoice_seal = "";
      this.fiveForm.filing_place = "";
      this.fiveForm.order_combo = "";
      this.fiveForm.order_item = [];
      this.fiveForm.license_auth = "";
      this.fiveForm.finance_buut_join = "";
      this.fiveForm.is_ukey = "";
      this.fiveForm.triple_agreement = "";
      this.fiveForm.social_security = "";
      this.fiveForm.accumula_fund = "";
      this.fiveForm.open_account = "";
      this.fiveForm.tax_scale = "";
      this.fiveForm.check_tax_cate = [];
      this.fiveForm.collect_type = "";
      this.fiveForm.legal_name = "";
      this.fiveForm.legal_phone = "";
      this.fiveForm.legal_id_number = "";
      this.fiveForm.net_finance_person = "";
    },
    fhandleCompanyInfoOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    handleClearSearchGetData() {
      this.searchArr.service_status = "";
      this.searchArr.consultant = null;
      this.searchArr.feature = null;
      this.searchArr.actual_reg_type = null;
      this.searchArr.operator = null;
      this.searchArr.platform = null;
      this.searchArr.park = null;
      this.searchStr.company_id = null;
      this.pageOption.currentPage = 1;
      this.searchVisible = false;
      this.handelGetOrders();
    },
    handleSearchGetData() {
      this.searchVisible = false;
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    getFrom() {
      this.$axios
        .get("api/admin/other_orders/get_froms")
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data;
          }
        })
        .catch();
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
  mounted() {
    this.handelGetOrders();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none;
.m-col
  margin: 8px 0 8px 0
.text-border
  border: 1px solid #dcdfe6
  border-radius: 5px
  line-height: 45px
  margin-bottom: .1rem
.count_style
  line-height: 28px
  display: inherit
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.border-line
  border: solid 1px red
.header-text
  line-height: 28px
  font-size: 16px
  color: #4d84fe
.card-margin
  margin-bottom: .4rem
.count_style
  display: inherit
  overflow: hidden
  text-overflow: ellipsiss
  white-space: nowrap
.check-succ
  color: #67C23A
.setBadge >>> .el-badge__content.is-fixed
  top: .22rem
  right: .06rem
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.tax_reg >>> .el-drawer__header
  font-size: .36rem
  font-weight: 400
  color: #4D84FE
.tax_reg >>> .el-table__header th
  color: #333333
.tax_reg >>> .el-timeline-item__node--normal
  left: 0
  background-color: #ECF4FF
.el-select, .el-cascader
  width: 100%
.tax_reg
  marginLeft()
  .count-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.clearfix:before,
.clearfix:after
  display: table
  content: ""
.clearfix:after
  clear: both
.search-row .el-col
  margin-bottom: .2rem
.count
  padding-left: .2rem
  line-height: .56rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.tr
  text-align: right
.top-line
  color: #409EFF
  font-weight: bold
.dot
  display: inline-block
  width: 0.1rem
  height: 0.1rem
  border-radius: 50%
  margin-right: 0.1rem
  top: 0
  left: -.2rem
  bottom: 0
  margin: auto
.mt-50
  margin-top: 1rem
.mt-10
  margin-top: .2rem
.mb-10
  margin-bottom: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .tabs-title
    color: #5789F4
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
.el-date-editor
  width: 100% !important
.ellipsis-link
  display: inline-block
  max-width: 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
.AIdrawer .drawer-title
  background-color: #ecf5ff
  padding: 10px
  color: #409EFF
</style>



// WEBPACK FOOTER //
// src/pages/customer/TaxReg.vue